module.exports = __webpack_public_path__ + "img/orange-circle-table-10.320d000a.png";